// Players and sources are server rendered. JavaScript only manages playback.
if (!customElements.get('koeed-gallery')) {
  customElements.define('koeed-gallery', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.videos = [...this.querySelectorAll('video')];
      this.videos.forEach(video => video.addEventListener('play', () => {
        this.videos.forEach(other => { if (other !== video) other.pause(); });
      }, options));
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.videos.forEach(video => video.pause());
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(({ target, isIntersecting }) => { if (!isIntersecting) target.pause(); });
        }, { rootMargin: '200px' });
        this.videos.forEach(video => this.observer.observe(video));
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}
